import { jsxs as h, jsx as a, Fragment as S } from "react/jsx-runtime";
import { useState as R, useEffect as x } from "react";
import { PromotionsRowBlock as I } from "../PromotionsRowBlock/PromotionsRowBlock.js";
import { ImageCard as b } from "../ImageCard/ImageCard.js";
import { Carousel as B } from "../Carousel/Carousel.js";
import { CtaBlock as v } from "../CtaBlock/CtaBlock.js";
import { classes as G } from "../../utils/helpers.js";
import '../../assets/PromotionsRowModule.css';const P = {
  paginationType: "dots",
  showControls: !0,
  controlButtonsOffset: -4,
  controlArrowSize: 48,
  showScrollbar: !1,
  startIndex: 0,
  variableHeight: !0,
  title: "",
  autoplay: !1,
  autoplayDelay: 3500,
  showPagination: !1,
  gutterSize: 0,
  slideAspectRatio: "4/2",
  slideGap: 1.5,
  cellsPerSlide: 4,
  cellAspectRatio: "unset",
  cellsPosition: "flex-start",
  wrapAround: !1
};
function T({ title: d = "", promos: n = [], handleClicks: o = null }) {
  const [u, w] = R([]), y = (t) => {
    console.log("event details:", t);
  };
  if (x(() => {
    const t = async (r) => {
      const c = await r.map((e) => {
        var l, i, s;
        return {
          title: "",
          layout: "ImageCard",
          props: {
            image: {
              url: e.image.url,
              altText: e.image.altText,
              aspectRatio: e.image.aspectRatio
            },
            title: e.title,
            content: e.content,
            handleClicks: o ?? y,
            relatedResourceId: e.id,
            overlayContent: e != null && e.overlayContent ? /* @__PURE__ */ a(
              v,
              {
                title: (l = e.overlayContent) == null ? void 0 : l.title,
                content: (i = e.overlayContent) == null ? void 0 : i.content,
                cta: (s = e.overlayContent) == null ? void 0 : s.cta
              }
            ) : "",
            cta: e.cta
          }
        };
      });
      w(c);
    };
    n.length > 4 && t(n);
  }, [n, o]), n.length <= 4)
    return /* @__PURE__ */ h("section", { className: "promotions-row", children: [
      /* @__PURE__ */ a("h2", { className: G(["h2", "promotions-row__header"]), children: d }),
      /* @__PURE__ */ a(I, { gap: "2rem", children: n.map((t) => {
        var r, c, e, l, i, s, C, f, g;
        return /* @__PURE__ */ a(
          b,
          {
            classname: t == null ? void 0 : t.classname,
            image: t.image,
            title: t.title,
            content: t.content,
            cta: t.cta,
            handleClicks: ((r = t == null ? void 0 : t.cta) == null ? void 0 : r.type) === "play-video" ? o ?? y : () => !0,
            relatedResourceId: t.id,
            overlayContent: t.overlayContent ? /* @__PURE__ */ a(
              v,
              {
                title: (c = t.overlayContent) == null ? void 0 : c.title,
                content: (e = t.overlayContent) == null ? void 0 : e.content,
                cta: (l = t.overlayContent) == null ? void 0 : l.cta,
                titleImageUrl: (i = t.overlayContent) == null ? void 0 : i.titleImageUrl,
                btnGradientStartColor: (s = t.overlayContent) == null ? void 0 : s.btnGradientStartColor,
                btnGradientEndColor: (C = t.overlayContent) == null ? void 0 : C.btnGradientEndColor,
                ctaButtonStyle: (f = t.overlayContent) == null ? void 0 : f.ctaButtonStyle,
                type: (g = t.overlayConent) == null ? void 0 : g.type
              }
            ) : ""
          },
          `promo-image-card-${Math.round(Math.random() * 1e7)}`
        );
      }) })
    ] });
  if (n.length > 4 && u.length) return /* @__PURE__ */ h(S, { children: [
    /* @__PURE__ */ a("h1", { className: ["h3", "promotions-row__header"].join(" "), children: d }),
    /* @__PURE__ */ a(
      B,
      {
        title: !0,
        slides: u,
        options: P,
        id: "promotions-row"
      }
    )
  ] });
}
export {
  T as PromotionsRowModule,
  T as default
};
